'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import {
  type AdServerAdBannerDimensions,
  AdServerBanner,
} from '../../../ad-server'
import { apmCaptureError } from '../../../apm'
import { useDeviceDetectorContext } from '../../../device-detector'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokAdBannerType } from '../../storyblok'

import { storyblokAdBannerGetDimensionsByDevice } from './storyblokAdBannerGetDimensionsByDevice'

/**
 * parse and return dimensions for ad banner
 *
 */
const useDimensions = (
  blok: StoryblokAdBannerType,
): AdServerAdBannerDimensions | undefined => {
  const { isMobile } = useDeviceDetectorContext()

  return storyblokAdBannerGetDimensionsByDevice(blok, isMobile)
}

export const StoryblokAdBanner: FC<
  StoryblokComponentProps<StoryblokAdBannerType>
> = ({ blok }) => {
  const dimensions = useDimensions(blok)
  const { adServerBannerTags } = blok

  if (!adServerBannerTags) {
    apmCaptureError(new Error('SB_AD_BANNER_MISSING_BANNER_TAGS'))

    return null
  }

  if (!dimensions) {
    return null
  }

  return (
    <AdServerBanner
      {...storyblokEditable(blok)}
      bannerTags={[adServerBannerTags]}
      dimensions={dimensions}
      showSkeleton
    />
  )
}
